import { render, staticRenderFns } from "./ModelAdd.vue?vue&type=template&id=56c2b067"
import script from "./ModelAdd.vue?vue&type=script&lang=js"
export * from "./ModelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports